import React from 'react';

export const FullscreenPortalContext = React.createContext(() => document.body);
